import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import set from 'lodash/set'
import { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import styled from 'styled-components'
import AreaSelectPanel from './SearchPanel/AreaSelectPanel'
import EtcSelectPanel from './SearchPanel/EtcSelectPanel'
import FeatureSelectPanel from './SearchPanel/FeatureSelectPanel'
import JobSelectPanel from './SearchPanel/JobSelectPanel'
import WageSelectPanel from './SearchPanel/WageSelectPanel'
import type { ConditionReducer, SearchParams, EtcParams } from './types'

interface PropsType {
  params: SearchParams
  conditionReducer: ConditionReducer
}

const PanelWrapper = styled.div`
  padding-top: 10px;
  padding-bottom: 20px;
`

const Panel = (props: PropsType) => {
  const { params, conditionReducer } = props

  const [etcParams, setEtcParams] = useState<EtcParams>()

  const changeEtcParams = (newParams: EtcParams) => {
    setEtcParams(newParams)
  }

  const mergedParams = () => {
    return { ...params.attributes, ...etcParams }
  }

  useEffect(() => {
    const etcCheckboxOptions = conditionReducer.attributes.etc_checkbox_options.filter((option) => !option.sp_only)
    const initialEtcParams = etcCheckboxOptions.reduce((conditions, option) => {
      const prevData: string[] = get(conditions, option.key, [])
      return set(conditions, option.key, prevData.concat(option.value.toString()))
    }, {})

    if (!isEmpty(initialEtcParams)) {
      setEtcParams(initialEtcParams)
    }
  }, [conditionReducer.attributes.etc_checkbox_options])

  return (
    <PanelWrapper>
      <AreaSelectPanel params={mergedParams()} conditionReducer={conditionReducer} />
      <JobSelectPanel params={mergedParams()} conditionReducer={conditionReducer} />
      <WageSelectPanel params={mergedParams()} />
      <FeatureSelectPanel params={mergedParams()} conditionReducer={conditionReducer} />
      {/* MEMO: /works?q[brand_ids][]=3973 など */}
      {!isEmpty(etcParams) && (
        <EtcSelectPanel params={params.attributes} etcParams={etcParams} conditionReducer={conditionReducer} changeEtcParams={changeEtcParams} />
      )}
    </PanelWrapper>
  )
}

export function renderSearchPanel() {
  const node = document.querySelector<HTMLElement>('.js-works-search-panel')
  if (node === null) return
  const params = node.dataset.worksSearchParams
  const conditionReducer = node.dataset.worksConditionReducer

  if (params === undefined || conditionReducer === undefined) return

  const root = createRoot(node)
  root.render(<Panel params={JSON.parse(params).data} conditionReducer={JSON.parse(conditionReducer).data} />)
}
